import { render } from "./ContratacaoVigenciaFinalizadaDetalheView.vue?vue&type=template&id=c2d6508a&scoped=true"
import script from "./ContratacaoVigenciaFinalizadaDetalheView.vue?vue&type=script&lang=js"
export * from "./ContratacaoVigenciaFinalizadaDetalheView.vue?vue&type=script&lang=js"

import "./ContratacaoVigenciaFinalizadaDetalheView.vue?vue&type=style&index=0&id=c2d6508a&scoped=true&lang=css"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2d6508a"]])

export default __exports__